import { navigateTo } from '#app'

export class BaseNavigation {
	static navigateTo(route: string, external: boolean = false): unknown {
		return navigateTo(route, {
			external,
		})
	}

	static navigateToNewTab(route: string): void {
		navigateTo(route, {
			open: {
				target: '_blank',
			},
		})
	}

	static navigateToExternalTab(route: string): void {
		navigateTo(this.getRouteWithProtocol(route), {
			open: {
				target: '_blank',
			},
			external: true,
		})
	}

	static getRouteWithProtocol(route: string): string {
		let finalRoute = route
		const hasProtocol = /^https?:\/\//i.test(route)

		if (!hasProtocol) finalRoute = `https:${route}`
		return finalRoute
	}
}
